import React, { useContext, useState } from 'react';
import { adminUserPut } from '../../api';
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/User';
import Modal from '../UI/Modal';
import { somethingWentWrongNotice, successAccountTypeChangeNotice } from '../UI/Notifications';
import { useForm } from 'react-hook-form';
import ChangeAccountTypeModalContent from '../ModalContents/ChangeAccountTypeModalContent';
import { SearchContext } from '../../context/Search';

const ChangeAccountType = ({ id, role }) => {
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const { setSearchTrigger, searchTrigger, setLoading } = useContext(SearchContext);
  const history = useHistory();
  const [show, setShow] = useState(false);
  const { handleSubmit } = useForm();
  const [inputRole , setInputRole] = useState(role);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push("/");
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout();
    } else {
      somethingWentWrongNotice("Change Account Type");
    }

    setLoading(false);
  }

  const onSubmit = () => {
    adminUserPut({role: inputRole}, {user_id: id})
      .then(() => {
        setSearchTrigger(!searchTrigger);
        handleClose();
        setLoading(false);
        successAccountTypeChangeNotice("Change Account Type");
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        handleClose();
        setLoading(false);
      });
  }

  const changeAccountType = () => {
    handleShow();
  }

  const onChangeHandler = (value) => {
    setInputRole(value.value)
  }

  return (
    <>
      <div
        onClick={() => changeAccountType()}
        className="Dropdown_Item"
      >
        <span className="ml-2">Change Account Type</span>
      </div>
      <Modal 
        handleClose={handleClose} 
        show={show}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        buttonLabel="Change"
      >
        <ChangeAccountTypeModalContent 
          role={role}
          onChangeHandler={onChangeHandler}
        />
      </Modal>
    </>
  )
}

export default ChangeAccountType;
